import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UpdateManualDataModel } from 'src/app/models/upload/update_manual_data.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';
import { UpdateManualDataService } from 'src/app/service/update-manual-data.service';

@Component({
  selector: 'app-update-goal-results',
  templateUrl: './update-goal-results.component.html',
  styleUrls: ['./update-goal-results.component.css']
})
export class UpdateGoalResultsComponent implements OnInit {
  goalsResultsData: UpdateManualDataModel[] = [];
  goalsResultsExcelData: UpdateManualDataModel[] = [];
  addGoal = new UpdateManualDataModel();
  public kpisList: UpdateManualDataModel[] = [];
  public complansList: UpdateManualDataModel[] = [];
  public calrunidsList: UpdateManualDataModel[] = [];


  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  resHeadder: string = 'Uploaded Goals';
  errorMessage: string;
  actions: any;
  actionButtons: any;
  buttons: Buttons[] = [];

  IsmodelShow: boolean = false;
  isAccessDisabled: boolean = false;
  exportExcelUserData: UpdateManualDataModel[] = [];

  constructor(private updateManualDataService: UpdateManualDataService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.getResults();
    this.initializeColumns();
    this.initializeExcelHeaders();

    console.log(this.updateManualDataService.updateManualDataModel);
    //this.goalsResultsData = this.updateManualDataService.updateManualDataModel;
    this.getCalRunIds();
    this.getCommPlans();
    this.getKpis();

    this.addGoal.upload_type = "manual";
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.uploadedGoalsResults;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    this.exportExcelUserData = JSON.parse(JSON.stringify(this.goalsResultsExcelData));
    console.log(this.exportExcelUserData);
    for (let js of this.exportExcelUserData) {
      delete js.id;
      delete js.commission_period;
      delete js.kpi;
    }
    //console.log(this.exportExcelUserData);
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelUserData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'Uploaded Goals',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  getResults() {
    if (this.updateManualDataService.updateManualDataModel) {
      this.updateManualDataService.searchGoalsResults(this.updateManualDataService.updateManualDataModel).subscribe((data: UpdateManualDataModel[]) => {
        this.goalsResultsData = data;
        this.goalsResultsExcelData = JSON.parse(JSON.stringify(data));
        console.log(this.goalsResultsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    }
  }

  public saveGoal(kpiForm: NgForm): void {

    if (!this.addGoal.sc_emp_id) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter SC EMP ID');
    } else if (!this.addGoal.cal_run_id) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Cal Run ID');
    } else if (!this.addGoal.comm_plan_id) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Commission Plan');
    } else if (!this.addGoal.kpi_id) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select KPI');
    } else if (!this.addGoal.yield_goal) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter Yield Goal');
    } else if (!this.addGoal.comm_plan_type) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Comm Plan Type');
    } else if (!this.addGoal.upload_type) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please enter Upload Type');
    } else {
      console.log(this.addGoal);
      this.updateManualDataService.saveGoal(this.addGoal).subscribe((data: UpdateManualDataModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Inserted Successfully');
        this.close(kpiForm, 'closeAddKPIButton');

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    }

  }

  close(form: NgForm, id: string) {
    form.reset();
    document.getElementById(id).click();
  }


  getGoalsById(id: any, empname: string) {
    console.log(id);
    this.updateManualDataService.getGoalsById(id).subscribe
      ((data: UpdateManualDataModel) => {
        console.log(JSON.stringify(data));
        this.updateManualDataService.editGoalsModel = data;
        this.updateManualDataService.editGoalsModel.empname = empname;
        console.log(this.updateManualDataService.editGoalsModel);
        this.router.navigate(['/update-goals-edit']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  public deleteGoal(id: number): void {
    console.log(id);
    if (confirm("Do you really want to delete?")) {
      this.updateManualDataService.deleteGoal(id).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.getResults();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }

  public getCalRunIds(): void {
    console.log("getActiveCorps called");
    this.updateManualDataService.getCalRunIds().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.calrunidsList = response;
        this.calrunidsList = this.calrunidsList.filter((v, i) => this.calrunidsList.findIndex(item => item.calrunid == v.calrunid) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getCommPlans(): void {
    console.log("getCommPlans called");
    this.updateManualDataService.getCommPlans().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.complansList = response;
        // console.log(this.complansList);
        this.complansList = this.complansList.filter((v, i) => this.complansList.findIndex(item => item.commplanid == v.commplanid) === i);
        // console.log(this.complansList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getKpis(): void {
    console.log("getKpis called");
    this.updateManualDataService.getKpis('Goals').subscribe(
      (response: UpdateManualDataModel[]) => {
        this.kpisList = response;
        //console.log(this.kpisList);
        this.kpisList = this.kpisList.filter((v, i) => this.kpisList.findIndex(item => item.kpiid == v.kpiid) === i);
        //console.log(this.kpisList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }


  innerRowAction1(row: any) {
    //console.log(row);
    console.log(row.row.id);

    if (row.value === 'Update') {
      // console.log(row.row);
      this.getGoalsById(row.row.id, row.row.empname);
      //this.getKomFeedDataByCorpHouseRep(row.row.corp, row.row.house, row.row.sales_rep_id, 'Update');
    }
    if (row.value === 'Delete') {
      //this.downloadPdf(row.row.comm_doc_str,row.row.doc_name)
      this.deleteGoal(row.row.id);
    }

  }

  actionOnButton(action: any) {
    if (action === "Add") {
      document.getElementById(action).click();
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.GoalsUpdateColumns;
        //console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }

    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-success btn-xs'
      }
    ]
    this.buttons = [

      {
        name: 'Back',
        pagenavigation: 'update-manual-data'
      }
    ]
  }
}